// extracted by mini-css-extract-plugin
export default {"twoCharts":"RadarChart_twoCharts__JJc5F","oneChart":"RadarChart_oneChart__XZYod"};